/*
 * Copyright 2026 NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";
import { ConfirmationDialogData } from "../../models/TokenModel";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: "app-confirmation-dialog",
  templateUrl: "./confirmation-dialog.component.html",
  styleUrls: ["./confirmation-dialog.component.scss"]
})
export class ConfirmationDialogComponent implements OnInit, OnDestroy {
  faCheck = faCheck;
  onClose: Subject<boolean> = new Subject();

  @Input() dialogData: ConfirmationDialogData = {
    title: "Confirmation",
    message: "",
    confirmButtonText: "Confirm",
    cancelButtonText: "Cancel"
  };

  constructor(private bsModalRef: BsModalRef) {}

  ngOnInit(): void {
    this.dialogData = {
      ...{ title: "Confirmation", message: "", confirmButtonText: "Confirm", cancelButtonText: "Cancel" },
      ...this.dialogData
    };
  }

  confirm(): void {
    this.onClose.next(true);
    this.bsModalRef.hide();
  }

  cancel(): void {
    this.onClose.next(false);
    this.bsModalRef.hide();
  }

  ngOnDestroy(): void {
    this.onClose.unsubscribe();
  }
}
